

















import { Component, Prop, Vue } from 'vue-property-decorator';
import html2canvas from 'html2canvas';

import ReTweet from './ReTweet.vue';
import TweetType from '../types/tweet';

@Component({
  components: {
    ReTweet,
  },
})
export default class Tweet extends Vue {
  @Prop() tweet!: TweetType;

  created() {
    let loopCount = 0;
    const timerId: number = setInterval(() => {
      if (!this.tweet.self) {
        return;
      }

      this.tweet.favorite += Math.floor(Math.random() * Math.floor(30));
      this.tweet.share += Math.floor(Math.random() * Math.floor(15));

      loopCount++;
      if (loopCount > 300) {
        clearInterval(timerId);
      }
    }, 100);
  }

  get id(): string {
    return `tweet${this.tweet.createdAt.split(':').join('')}`;
  }

  favorite() {
    this.tweet.favorite += 1;
  }

  async share() {
    this.tweet.share += 1;
    // TODO: twitterへのシェア機能
    // const canvas = await html2canvas(document.getElementById(`${this.id}`)!);
    // const url =
    //   'https://twitter.com/intent/tweet?text=' +
    //   this.tweet.content +
    //   '%20%23koedame' +
    //   '&url=' +
    //   'https://tocomi-koedame.firebaseapp.com/';
    // const option = 'status=1,width=600,height=600,top=100,left=100';
    // window.open(url, 'twitter', option);
  }
}
